import Navbar from '../components/Navbar'
import FillInTheBlanksComp from '../components/FillInTheBlanksComp'
import Footer from '../components/Footer'

function FillInTheBlanks() {
  return (
    <>
    <Navbar />
    <FillInTheBlanksComp />
    <Footer />
    </>
  )
}

export default FillInTheBlanks


